import { useGlobalPeriod } from "@iliotech/data-wire";

import { CHART_DATE_FORMAT, useStructureGrouping } from "@iliotech/data-wire";
import moment from "moment";
import { ITimePeriod } from "src/main";

interface IProps {
  cell: any;
  store: any;
  pageId: string;
  cellId: string;
  inceptionDateOverride?: string;
}
export const useFakePeriodContext = ({ cell, store, ...props }: IProps) => {
  const setCellPeriod = (newPeriod: ITimePeriod) => {
    console.log({ newPeriod });
    if (!cell.periodContext) {
      store.updateCell(props.pageId, props.cellId, "periodContext", {
        inceptionDate: props.inceptionDateOverride,
        period: newPeriod,
        periodForRequest: globalPeriodContext.periodForRequest,
        setPeriod: setCellPeriod,
        epochDate: globalPeriodContext.epochDate,
        periodDays: globalPeriodContext.periodDays,
        periodString: globalPeriodContext.periodString,
        setEpochDate: globalPeriodContext.setEpochDate,
      });
    } else {
      store.updateCell(props.pageId, props.cellId, "periodContext", {
        ...cell.periodContext,
        period: newPeriod,
        periodDays: moment(newPeriod.to).diff(moment(newPeriod.from), "days"),
        periodString:
          moment(newPeriod.from).format(CHART_DATE_FORMAT) +
          " - " +
          moment(newPeriod.to).format(CHART_DATE_FORMAT),
        periodForRequest: {
          from: newPeriod.from
            ? moment(newPeriod.from).format("YYYY-MM-DD")
            : undefined,
          to: newPeriod.to
            ? moment(newPeriod.to).format("YYYY-MM-DD")
            : undefined,
        },
      });
    }
  };
  const cellPeriodContext = cell.periodContext;
  const globalPeriodContext = useGlobalPeriod();
  const defaultPeriodContext = {
    ...globalPeriodContext,
    setPeriod: setCellPeriod,
  };
  const periodContext = cellPeriodContext || defaultPeriodContext;
  return { periodContext, setCellPeriod };
};
